import React from 'react'
import './Footer.css'
const Footer = () => {
    
  return (
    <div className="footer">
        <p className='small-text'>© {new Date().getFullYear()} Oriental Daily Sdn Bhd (200201013064). All Rights Reserved.</p>
        <p></p>
    </div>
  )
}

export default Footer